// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"96":"1ef912e8","400":"5ab06455","972":"05ab64c3"}[chunkId] + ".js";
};